// extracted by mini-css-extract-plugin
module.exports = {"hidden":"OBTScrollbar_hidden__P4tTb"};